import type { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export interface IProps extends React.PropsWithChildren {
  canOrder?: boolean;
  id: UniqueIdentifier;
  value?: React.ReactNode;
}

const CustomListItemContainer: React.FC<IProps> = React.memo(
  ({ children, canOrder, id, value }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
      id
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition
    };

    return (
      <div
        style={style}
        className={'flex min-h-[30px] select-none gap-2 bg-white hover:bg-gray-100 pt-2'}
      >
        {canOrder && (
          <div ref={setNodeRef} {...attributes} {...listeners} id={`${id}`}>
            <FontAwesomeIcon
              className="my-auto h-[20px] w-[20px] cursor-move self-center py-2 align-middle text-gray-300 hover:border-gray-500 hover:text-gray-500"
              icon={faGripDotsVertical as IconProp}
            />
          </div>
        )}

        <div className="relative my-auto grow self-center px-1 py-2 align-middle">{value}</div>
        {children}
      </div>
    );
  }
);

CustomListItemContainer.displayName = 'CustomListItemContainer';

export default CustomListItemContainer;
